import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorViewStyle as S } from "components/ErrorView/ErrorView.style";
import { LoadingPage } from "components/LoadingPage/LoadingPage";
import { useChurnBanner } from "hooks/useChurnBanner";
import { useChurnTransactionsPath } from "hooks/useChurnTransactionsPath";
import { PButton } from "@prime/PButton/PButton";
import { MatIcon } from "components/MatIcon/MatIcon";
import { getAuthService } from "services/auth.service";

export const ChurnBlockedView: React.FC<{}> = () => {
  const navigate = useNavigate();
  const transactionsPath = useChurnTransactionsPath();

  // Fire the inactive banner here too: when the route is blocked, LoggedInModuleHOC never mounts,
  // so this landing page is the only surface that can show it for a user with no transactions access.
  useChurnBanner();

  useEffect(() => {
    if (transactionsPath) {
      navigate(transactionsPath, { replace: true });
    }
  }, [transactionsPath, navigate]);

  // Still resolving, or redirecting to transactions — show nothing blocking in the meantime.
  if (transactionsPath === undefined || transactionsPath) {
    return <LoadingPage />;
  }

  return (
    <S.ErrorView>
      <div>
        <h1>This account is inactive</h1>
        <p>
          <span>
            Your account is currently inactive. To reactivate it, please get in touch with your representative
            or contact us at{" "}
          </span>
          <a href="mailto:support@goideally.com">support@goideally.com</a>.
        </p>
        <PButton
          className="mt-3"
          label="Log out"
          icon={<MatIcon>logout</MatIcon>}
          onClick={() => getAuthService().logout()}
        />
      </div>
    </S.ErrorView>
  );
};
